import React, { useEffect } from 'react';
import { useMount } from '@shared/utils/hooks/useMount';
import { useAuth } from '@shared/components/AuthProvider';
import { useCreateEventState } from '@shared/createEvent/CreateEventState';
import { TyingTheKnotContainer } from '@shared/createEvent/TyingTheKnotContainer';

import { useCreateBabyRegistryTelemetry } from '@apps/createBabyRegistry/CreateBabyRegistry.telemetry';
import { useRedirectFromCreateBabyRegistry } from '@apps/createBabyRegistry/hooks/useRedirectFromCreateBabyRegistry';

import { wrapWithTyingTheKnotHealthProvider } from './TyingTheKnot.health';

export const TyingTheKnot = wrapWithTyingTheKnotHealthProvider(() => {
  const telemetry = useCreateBabyRegistryTelemetry();
  const { isLoggedIn, isCurrentUserSettled } = useAuth();
  const handleRedirect = useRedirectFromCreateBabyRegistry();
  const { isEventCreationSettled, createdEventData, createError } = useCreateEventState();

  const website = createdEventData?.createEventV0301?.website;

  useEffect(() => {
    if (isCurrentUserSettled && isLoggedIn && isEventCreationSettled && website) {
      handleRedirect(website);
    }
  }, [website, isCurrentUserSettled, isEventCreationSettled, isLoggedIn, handleRedirect]);

  useMount(() => {
    telemetry.tyingTheKnot.enter();
  });

  return <TyingTheKnotContainer error={createError} />;
});
